import { useRef } from "react";

import Link from "next/link";

import styles from "~/components/Faq/FaqPillButtonContainer.module.scss";

import FaqPillButton from "~/components/Faq/FaqPillButton";

const FaqPillButtonContainer = ({
  searchSubmitted,
  setSelectedPill,
  setSearch,
  selectedPill,
  currentFaqContent,
  staleSearchValue,
  pillButtons,
  setHideUnselectedState,
}) => {
  const pillButtonWrapperRef = useRef(null);

  return (
    <>
      <div
        ref={pillButtonWrapperRef}
        className={styles["FaqPillButtonContainer"]}
      >
        {pillButtons.map((button, index) => (
          <FaqPillButton
            setSelectedPill={setSelectedPill}
            setSearch={setSearch}
            button={button}
            key={index}
            index={index}
            selectedPill={selectedPill}
            pillButtonWrapperRef={pillButtonWrapperRef}
            setHideUnselectedState={setHideUnselectedState}
          />
        ))}
      </div>
      {currentFaqContent?.length > 0 && (
        <div
          className={styles["FaqPillButtonContainer__search-header-wrapper"]}
        >
          {searchSubmitted && (
            <h2 className={styles["FaqPillButtonContainer__sub-heading"]}>
              {currentFaqContent?.length}{" "}
              {currentFaqContent?.length === 1 ? "result" : "results"} for
              &quot;
              {staleSearchValue}
              &quot;
            </h2>
          )}
        </div>
      )}
    </>
  );
};

export default FaqPillButtonContainer;
